import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

import { useSelector } from 'react-redux';
import OperadorRoutes from './OperadorRoutes';
import SupervisorRoutes from './SupervisorRoutes';
import SupportRoutes from './SupportRoutes';
import PublicRoutes from './PublicRoutes';
import ManagerRoutes from './ManagerRoutes';
import LeaderRoutes from './LeaderRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const customization = useSelector((state) => state.customization);
    const RutasPrincipales = useRoutes([MainRoutes, PublicRoutes]);
    const GeneralRoutes = useRoutes([AuthenticationRoutes, PublicRoutes]);
    const RoutesOperador = useRoutes([OperadorRoutes, PublicRoutes]);
    const RoutesLeader = useRoutes([LeaderRoutes, PublicRoutes]);

    const RoutesSupervisor = useRoutes([SupervisorRoutes, PublicRoutes]);
    const RoutesManager = useRoutes([ManagerRoutes, PublicRoutes]);
    const RoutesSupport = useRoutes([SupportRoutes]);

    if (customization.autenticated === true) {
        if (customization.userData.roles === undefined) {
            return GeneralRoutes;
        } else {
            if (customization.userData.roles[0].systemName === 'SUPER_USER') {
                return RutasPrincipales;
            } else if (customization.userData.roles[0].systemName === 'OPERATOR') {
                return RoutesOperador;
            } else if (customization.userData.roles[0].systemName === 'SUPERVISOR') {
                return RoutesSupervisor;
            } else if (customization.userData.roles[0].systemName === 'SUPPORT') {
                return RoutesSupport;
            } else if (customization.userData.roles[0].systemName === 'MANAGER') {
                return RoutesManager;
            } else if (customization.userData.roles[0].systemName === 'SHIFT_LEADER') {
                return RoutesSupervisor;
            }
        }
    } else {
        return GeneralRoutes;
    }
}
